import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_CONTRACT_LABOR_CONFIRM } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_CONTRACT_LABOR_CONFIRM
    }
};

export const contractLaborConfirmSlice = createSlice({
    name: 'contractLaborConfirm',
    initialState,
    reducers: {
        searchContractLaborConfirm: (state, action) => {
            state.search = action.payload;
        },
        searchContractLaborConfirmPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = contractLaborConfirmSlice;
export const { searchContractLaborConfirm, searchContractLaborConfirmPageFirst } = actions

export const selectSearchLaborContractConfirm = (state) => state?.features?.contractLaborConfirm?.search

export default reducer


